import { css } from 'styled-components';
import { componentColors } from '../cloudcharge/component-colors';
import { semanticColors } from '../cloudcharge/semantic-colors';
import { semanticTypography } from '../cloudcharge/semantic-typography';
import { primitiveColors } from '../colors';
import { buildComponentSizes } from '../component-sizes';
import { semanticSizes } from '../semantic-sizes';
import { primitiveSizes, spacing, spacingRaw } from '../sizes';
import { Theme } from '../theme';
import { fontCode } from '../font-code';

const colorPrimary = '#444';
const colorSecondary = '#999';

export const base: Theme = {
    name: 'Base',

    // Variables
    mainSideMargin: spacingRaw(4),
    mainTopBottomMargin: spacingRaw(8),
    sectionMargin: spacingRaw(6),
    relatedItemsMargin: spacingRaw(4),
    smallItemsPadding: spacingRaw(2),

    // Colors
    ...semanticColors,
    ...semanticSizes,
    primitiveColors,
    componentColors,
    componentSizes: buildComponentSizes(semanticTypography),
    colorPrimary,
    colorSecondary,
    colorTextDisabled: '#999',
    modalBackgroundColor: '#fff',
    firstSideBackgroundColor: '#eee',
    secondSideBackgroundColor: '#fff',
    iconStrokeColor: 'black',

    errorColor: 'red',
    activeColor: 'blue',
    successColor: 'green',
    disabledColor: '#999',
    focusColor: 'black',
    avatarColorPalette: ['#B9502B', '#FA9081', '#D5CB9C', '#5975C5', '#FAA916'],

    // Typography
    typography: semanticTypography,
    fontBase: 'Verdana, sans-serif',
    fontCode,
    fontFace: css``,
    textColor: colorPrimary,
    headerColor: colorPrimary,
    textSize: '16px',
    lineHeight: '20px',
    descriptionSize: '14px',
    descriptionColor: colorSecondary,
    descriptionLineHeight: '18px',
    descriptionSmall: '12px',

    // Button
    buttonTextColorPrimary: '#fff',
    buttonColorPrimary: colorPrimary,
    buttonTextColorPrimaryAlternative: '#000',
    buttonColorPrimaryAlternative: '#fff',
    buttonTextColorSecondary: '#fff',
    buttonColorSecondary: colorSecondary,
    buttonTextColorDisabled: '#BBB',
    buttonColorDisabled: '#DDD',
    buttonColorTertiary: '#fff',
    buttonBorderTertiary: '1px solid #000000',

    linkTextColor: '#4F4F4F',
    actionLinkTextColor: '#4F4F4F',

    // Input
    inputBorderColor: colorSecondary,
    inputActiveColor: colorPrimary,
    inputLabelColor: 'black',

    inputBackground: '#fff',
    inputActiveBackground: '#eee',
    inputReadOnlyBackground: '#fff',
    inputReadOnlyActiveBackground: '#fff',
    inputBorder: '1px solid #eee',
    inputBorderActive: '2px solid #000',
    inputBorderReadOnly: '2px solid #eee',
    inputBorderReadOnlyActive: '2px solid #000',
    inputInputColor: 'black',
    inputMessageBorder: '2px solid',
    inputMessageColor: 'white',
    inputMessageColorInfo: colorPrimary,
    inputMessageColorError: 'red',
    inputReadOnlyIconColor: '#eee',

    // Progressindicator
    progressDonutRingColor: '#eee',
    progressDonutIndicatorColor1: colorPrimary,
    progressDonutIndicatorColor2: colorSecondary,
    progressIndicatorColor: '#000000',
    progressSpinnerColor: '#4C4C51',

    // List
    listHeaderColor: 'black',
    tableHeaderColor: 'black',

    // Simple Table
    simpleTableBorderColor: 'black',
    simpleTableHeaderColor: 'black',
    simpleTableBodyColor: 'black',

    // Card
    cardBorder: '1px solid #f2f2f2',
    cardBorderActive: `2px solid ${colorPrimary}`,
    cardBorderPrint: '1px solid #aaa',
    cardBackground: '#fff',
    cardBackgroundActive: colorPrimary,
    cardTextActive: '#fff',
    cardSupportingTextColor: primitiveColors.gray[750],
    cardBorderRadius: `${primitiveSizes.radius.standard}px`,
    cardPadding: spacingRaw(4),
    cardPaddingLarge: spacingRaw(6),

    // Selectable Grid Item
    selectableBorderColor: '#ccc',
    selectableBorderColorFocus: '#000',
    selectableBorderColorActive: colorPrimary,

    // accordion
    accordionBorder: '1px solid #f2f2f2',
    accordionBorderActive: `2px solid ${colorPrimary}`,
    accordionBorderDisabled: '2px solid #999',
    accordionTitleColor: colorPrimary,
    accordionTitleColorDisabled: '#999',

    // Menu
    menuBackgroundColor: '#fff',
    menuDividerColor: '#ccc',

    // Side menu
    sideMenuIconColor: '#AAA',
    sideMenuAlternativeBackground: '#eee',

    // Avatar
    checkedAvatarColor: colorPrimary,
    avatarSecondaryColor: '#000',

    // Chip
    chipColor: '#ddd',

    // RadioList
    radioListBackgroundColors: ['#fff', '#ffe', '#fee'],
    radioListTextColors: ['#000', '#003', '#006'],

    // Group
    groupDivider: '#ccc',

    // Tooltip
    tooltipBackground: '#000',
    tooltipBorder: 'none',
    tooltipBorderRadius: '4px',
    tooltipColor: '#fff',
    tooltipShadow: '0px 2px 10px 0px #00000012',

    // Toast
    toastBackground: '#000',
    toastBorder: 'none',
    toastBorderRadius: '4px',
    toastTitleColor: '#fff',
    toastColor: '#ddd',
    toastShadow: '0px 2px 10px 0px #00000012',

    spacing,
    spacingRaw,
    ...primitiveSizes,
};
